export default "__VITE_ASSET__CqTlHawc__"